import { useState } from 'react'

import { gql, useMutation } from '@apollo/client'
import AskUserConfirmation from 'Root/App/Dialog/ask-user-confirmation'

import RemoveButton from './Row/remove-button'
import RemoveUserAuthorizationAlert from './Row/remove-user-auth-alert'
import GroupAuthSelect from './group-auth-select'

export interface RemoveAuthorizationGroup {
  removeAuthorizationGroup: boolean
}

export interface RemoveAuthorizationgGroupVariables {
  id: string
}

const REMOVE_AUTHORIZATION_GROUP = gql`
  mutation RemoveAuthorizationGroup($id: ID!) {
    removeAuthorizationGroup(id: $id)
  }
`

const GroupAuthorizationRowItem = ({ groupAuth, elementId }) => {
  const groupAuthId = groupAuth.id || ''
  const groupAuthValue = groupAuth.value || ''
  const groupName = groupAuth.group?.name || ''
  const groudId = groupAuth.group?.id || ''
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false)
  const [mutate, { loading }] = useMutation<
    RemoveAuthorizationGroup,
    RemoveAuthorizationgGroupVariables
  >(REMOVE_AUTHORIZATION_GROUP, {
    refetchQueries: ['GetElementAuthorizationForGroups'],
  })

  const handleAuthorizationRemove = async () => {
    await mutate({
      variables: {
        id: groupAuthId,
      },
    })

    setOpenRemoveDialog((openDialog) => !openDialog)
  }

  const onCloseFn = !loading
    ? () => setOpenRemoveDialog((openRemoveDialog) => !openRemoveDialog)
    : () => null

  return (
    <div
      className="flex flex-col gap-3 p-3 sm:flex-row sm:gap-1"
      key={groupAuthId}
      role="listitem"
    >
      <div className="flex flex-row gap-2 flex-grow">
        <div className="flex flex-col my-auto text-sm text-gray-600">
          <div className="font-medium">{groupName}</div>
        </div>
      </div>

      <div className="flex flex-row gap-1">
        <GroupAuthSelect
          elementId={elementId}
          authValue={groupAuthValue}
          groupId={groudId}
        />
        <RemoveButton onRemoveCallback={() => setOpenRemoveDialog(true)} />
      </div>

      {openRemoveDialog && (
        <AskUserConfirmation openDialog={openRemoveDialog} onClose={onCloseFn}>
          <RemoveUserAuthorizationAlert
            onConfirm={handleAuthorizationRemove}
            onClose={onCloseFn}
            isRemoving={loading}
          />
        </AskUserConfirmation>
      )}
    </div>
  )
}

export default GroupAuthorizationRowItem
